// extracted by mini-css-extract-plugin
export var btnWrapper = "ViewMore-module--btnWrapper--7cc7c";
export var content = "ViewMore-module--content--a2b83";
export var hidden = "ViewMore-module--hidden--9cf7a";
export var mask = "ViewMore-module--mask--478d1";